module.exports = __webpack_public_path__ + "r-v3/img/pen_white.244e9432.svg";